module.exports = __webpack_public_path__ + "img/s2-0.02e10655.svg";